import { IconWrapper } from '../runtime';
export default IconWrapper('show-border', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M1.75 3.24976C1.75 2.42133 2.42157 1.74976 3.25 1.74976H12.75C13.5784 1.74976 14.25 2.42133 14.25 3.24976V12.7498C14.25 13.5782 13.5784 14.2498 12.75 14.2498H3.25C2.42157 14.2498 1.75 13.5782 1.75 12.7498V3.24976Z",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "vector-effect": "non-scaling-stroke"
    }
  }), h("path", {
    "attrs": {
      "d": "M5 5.29976C5 5.13407 5.13431 4.99976 5.3 4.99976H10.7C10.8657 4.99976 11 5.13407 11 5.29976V10.6998C11 10.8654 10.8657 10.9998 10.7 10.9998H5.3C5.13431 10.9998 5 10.8654 5 10.6998V5.29976Z",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "vector-effect": "non-scaling-stroke"
    }
  })]);
});